import Config from 'src/internal/common/config';
import {DEFAULT_OBSERVABILITY_CONFIG} from 'src/internal/constants';

// Stores the `initObservability` config which is used by imperative methods
// of @sail/observability. Delete once we move to a declarative initialization.
export default new Config(DEFAULT_OBSERVABILITY_CONFIG);
